import './tulips2/style';
import FormStructure from './tulips2/form_structure';

export default FormStructure;